import axios from "axios";

axios.defaults.headers.common["X-CSRF-TOKEN"] = document.cookie.split("=")[1];

//const baseUrl = 'http://localhost:4810/Api';

export default {

  AddDevelopment(OBJ) {
    return axios.post("/Api/Admin/DevelopmentTrainingPrograms/Add", OBJ);
    },
    ConfirmUser(Id) {
        return axios.post(`/Api/Admin/User/Confirm/${Id}`);
    },
    ResendEmail(Id) {
        return axios.post(`/Api/Admin/User/ResendEmail/${Id}`);
    },
  GetDevelopmentTraining() {
    return axios.get(`/Api/Admin/DevelopmentTrainingPrograms/Get`);
  },
  GetDevelopmentTrainingUnits() {
    return axios.get(
      `/Api/Admin/DevelopmentTrainingPrograms/DevelopmentTrainingUnits/Get`
    );
  },
  GetDevelopmentTrainingProgramBy(id) {
    return axios.get(`/Api/Admin/DevelopmentTrainingPrograms/Get/${id}`);
  },
  GetAllDevelopmentTrainingPrograms() {
    return axios.get(`/Api/Admin/DevelopmentTrainingPrograms/Get/All`);
  },
  EditDevelopmentTrainingProgram(object) {
    return axios.post(`/Api/Admin/DevelopmentTrainingPrograms/Edit`, object);
  },
  GetDevelopmentTrainingGoals() {
    return axios.get(
      `/Api/Admin/QualifyingTraining/GetDevelopmentTrainingGoals`
    );
  },
  ReadTheNotification(status, NotificationUserId) {
    return axios.get(
      `/Api/Admin/Notifications/ReadTheNotification/${status}/${NotificationUserId}`
    );
  },
  //GetCrtificatePDF(Code, name, nameEng, CertificateData, CertificateId) {
  //  return axios.get(
  //    `/Api/Admin/TrainingFoundations/GetCrtificatePDF?Code=${Code}&name=${name}&nameEng=${nameEng}&CertificateData=${CertificateData}&CertificateId=${CertificateId}`
  //  );
  //},
    GetCrtificatePDF(Code, name, nameEng, CertificateData, CertificateId) {
    return axios.get(
        `/Api/Admin/Reports/GetPermissionToPractice?Code=${Code}&name=${name}&nameEng=${nameEng}&CertificateData=${CertificateData}&CertificateId=${CertificateId}`, {
        responseType: "blob",
    });
  },
  GetNotification(Status) {
    return axios.get(
      `/Api/Admin/Notifications/GetNotifications?Status=${Status}`
    );
  },
  GetCalendar(TrainingFoundationId) {
    return axios.get(
      `/Api/Admin/Calendar/GetCalendar?TrainingFoundationId=${TrainingFoundationId}`
    );
  },
  GetNotificationPages(Status, pageNo, pageSize) {
    return axios.get(
      `/Api/Admin/Notifications/GetNotificationPages?pageNo=${pageNo}&pagesize=${pageSize}&Status=${Status}`
    );
  },
    Print(ApprovalId) {
        return axios.get(`/Api/Admin/Reports/ReportPrint?ApprovalId=${ApprovalId}`, {
            responseType: "blob",
        });
    },

    GetCrtificateWPDF(Code, name, nameEng, CertificateData, CertificateId) {
        return axios.get(
            `/Api/Admin/Reports/GetCrtificateWPDF?Code=${Code}&name=${name}&nameEng=${nameEng}&CertificateData=${CertificateData}&CertificateId=${CertificateId}`
            , {
                responseType: "blob",
            });
    },

  GetStages() {
    return axios.get(`/Api/Admin/Home/GetStages`);
  },
  GetActiveEvidence() {
    return axios.get(`/Api/Admin/Avidence/GetEvidence`);
  },
  AddEvidences(OBJ) {
    return axios.post("/Api/Admin/Avidence/AddEvidences", OBJ);
  },
  GetEvidenceById() {
    return axios.get(`/Api/Admin/Avidence/Get`);
  },
    getUser(pageNo, pageSize, OfficeId) {
    return axios.get(
        `/Api/Admin/User/getUser?pageNo=${pageNo}&pagesize=${pageSize}&OfficeId=${OfficeId}`
    );
  },
  AddUser(User) {
      return axios.post("/Api/Admin/User/Add", User);
  },

  EditUser(User) {
    return axios.post("/Api/Admin/User/EditUser", User);
  },

  DeactivateUser(UserId) {
    return axios.post(`/Api/Admin/User/${UserId}/Deactivate`);
  },

  ActivateUser(UserId) {
    return axios.post(`/Api/Admin/User/${UserId}/Activate`);
    },

    DeleteUser(UserId) {
      return axios.post(`/Api/Admin/User/${UserId}/Delete`);
  },

  UploadImage(obj) {
    return axios.post("/Api/Admin/User/UploadImage", obj);
  },
  ResetPassword(email) {
    return axios.post(`/Security/ResetPassword/${email}`);
  },
  EditUsersProfile(User) {
    return axios.post("/Api/Admin/User/EditUsersProfile", User);
  },
    //******************************** Chats *******************************************
    GetInbox(sender_type) {
        return axios.get(`/Api/Admin/Chats/GetInbox?sender_type=${sender_type}`);
    },

    GetAllChatsInfo(Object) {
        return axios.post(`/Api/Admin/Chats/Get`, Object);
    },
    GetChatsById(id, Received_type, Sender_type) {
        return axios.get(`/Api/Admin/Chats/GetChatsById?id=${id}&Received_type=${Received_type}&Sender_type=${Sender_type}`);
    },

    SendMessage(bodyObject) {
        return axios.post(`Api/Admin/Chats/SendMessage`, bodyObject);
    },
  ChangePassword(userPassword) {
    return axios.post(`/Security/ChangePassword`, userPassword);
  },
    GetOffice() {
        return axios.get(`/Api/Admin/User/GetOffices`);
    },
  IsLoggedin() {
    return axios.get(`/Security/IsLoggedin`);
  },

  loginUser(OBJ) {
    return axios.post(`/Security/loginUser`, OBJ);
  },
  Logout() {
    return axios.post(`/Security/Logout`);
  },
  ChangePasswords(object) {
    return axios.post(`/Api/Admin/User/ChangePassword`, object);
  },

  GetSurveys() {
    return axios.get(`/Api/Admin/Survey/Get`);
    },
    // *********************************** Offices ***********************************
    GetOffices(MunicipalityId, pageNo, pageSize) {
        return axios.get(
            `/Api/Admin/Offices/Get?MunicipalityId=${MunicipalityId}&pageno=${pageNo}&pagesize=${pageSize}`
        );
    },
    DeactivateOffice(OfficeId) {
        return axios.post(`/Api/Admin/Offices/${OfficeId}/Deactivate`);
    },

    ActivateOffice(OfficeId) {
        return axios.post(`/Api/Admin/Offices/${OfficeId}/Activate`);
    },
    GetOfficeBy(MunicipalityId) {
        return axios.get(`/Api/Admin/Offices/Get/Municipality/${MunicipalityId}`);
    },
    GetOfficeByOfficeId(OfficeId) {
        return axios.get(`/Api/Admin/Offices/Get/Office/${OfficeId}`);
    },
    AddOffice(OBJ) {
        return axios.post(`/Api/Admin/Offices/Add`, OBJ);
    },
    DeleteOffice(OfficeId) {
        return axios.post(`/Api/Admin/Offices/${OfficeId}/Delete`);
    },
    EditOffice(object) {
        return axios.post(`/Api/Admin/Offices/Edit`, object);
    },
    GetAllOffices() {
        return axios.get(`/Api/Admin/Offices/Get/All`);
    },
  // **********************************    TrainingFoundations ***********************
  GetTrainingFoundations(pageNo, pageSize) {
    return axios.get(
      `/Api/Admin/TrainingFoundations/Get?pageno=${pageNo}&pagesize=${pageSize}`
    );
  },
  GetAllTrainingFoundations() {
    return axios.get(
      `/Api/Admin/TrainingFoundations/GetAllTrainingFoundations`
    );
  },
  ConfirmTrainingFoundations(TrainingId) {
    return axios.post(`/Api/Admin/TrainingFoundations/Confirm/${TrainingId}`);
  },
  RejectTrainingFoundations(TrainingId) {
    return axios.post(`/Api/Admin/TrainingFoundations/Reject/${TrainingId}`);
  },
  GetTrainingFoundationBy() {
    return axios.get(`/Api/Admin/TrainingFoundations/Get`);
  },
  GetEvidenceInfo() {
    return axios.get(`/Api/Admin/Avidence/GetEvidenceInfo`);
  },
  EditTrainingFoundationBy(object) {
    return axios.post(`/Api/Admin/TrainingFoundations/Edit`, object);
  },

  // **********************************    Trainers ***********************
  GetTrainers(pageNo, pageSize) {
    return axios.get(
      `/Api/Admin/Trainers/Get?pageno=${pageNo}&pagesize=${pageSize}`
    );
  },
  GetAllTrainers() {
    return axios.get(`/Api/Admin/Trainers/GetAllTrainers`);
  },
  ConfirmTrainers(TrainingId) {
    return axios.post(`/Api/Admin/Trainers/Confirm/${TrainingId}`);
  },
  RejectTrainers(TrainingId) {
    return axios.post(`/Api/Admin/Trainers/Reject/${TrainingId}`);
  },
  // ***************************************  Applications **************************
  GetApplications(TrainingId, pageNo, pageSize) {
    return axios.get(
      `/Api/Admin/Applications/Get?TrainingFoundationId=${TrainingId}&pageno=${pageNo}&pagesize=${pageSize}`
    );
  },
  ConfirmApplicatinos(ApplicationId) {
    return axios.post(`/Api/Admin/Applications/Confirm/${ApplicationId}`);
  },
  RejectApplicatinos(ApplicationId, Obj) {
    return axios.post(`/Api/Admin/Applications/Reject/${ApplicationId}`, Obj);
  },



  // *************************************Calendar****************************************

  GetCalendarFullInfo(pageNo, pageSize, trainingFoundationId) {
    return axios.get(
      `/Api/Admin/Calendar/GetCalendarFullInfo?pageno=${pageNo}&pagesize=${pageSize}&trainingFoundationId=${trainingFoundationId}`
    );
  },

  ConfirmEventTime(id) {
    return axios.post(`/Api/Admin/Calendar/${id}/ConfirmEventTime`);
  },

  // *************************************Classes****************************************
  GetClasses() {
    return axios.get(`/Api/Admin/Classes/Get/All`);
  },
  GetClass(pageNo, pageSize) {
    return axios.get(
      `/Api/Admin/Classes/GetClasses?pageno=${pageNo}&pagesize=${pageSize}`
    );
  },
  // *************************************ReportTrainingProgram****************************************
  AddNewReport(objet) {
    return axios.post(`/Api/Admin/ReportTrainingProgram/Add`, objet);
  },
  GetReportTrainingPrograms(pageNo, pageSize) {
    return axios.get(
      `/Api/Admin/ReportTrainingProgram/GetPrograms?pageno=${pageNo}&pagesize=${pageSize}`
    );
  },
  DeleteReportTrainingPrograms(reportId) {
    return axios.post(`/Api/Admin/ReportTrainingProgram/${reportId}/Delete`);
  },
  // *************************************Qualifying Training Info****************************************
  AddQualifyingTraining(obj) {
    return axios.post(`/Api/Admin/QualifyingTraining/AddExistingCourse`, obj);
  },
  EditQualifyingTraining(requestId, obj) {
    return axios.post(
      `/Api/Admin/QualifyingTraining/EditExistingCourse/${requestId}`,
      obj
    );
  },
  AddNotExistingCourse(obj) {
    return axios.post(
      `/Api/Admin/QualifyingTraining/AddNotExistingCourse`,
      obj
    );
  },
  GetQualifyingTrainingName() {
    return axios.get(`/Api/Admin/QualifyingTraining/GetQualifyingTrainingName`);
  },
  GetQualifyingTraining(Id) {
    return axios.get(
      `/Api/Admin/QualifyingTraining/GetQualifyingTraining/${Id}`
    );
  },
  GetQualifyingTrainingV1(Id, RequestId) {
    return axios.get(
      `/Api/Admin/QualifyingTraining/GetQualifyingTrainingV1/${Id}/${RequestId}`
    );
  },
  GetQualifyingTrainingRequestedCourses(pageNo, pageSize, IsExist, QTID) {
    return axios.get(
      `/Api/Admin/QualifyingTraining/GetCourses?pageno=${pageNo}&pagesize=${pageSize}&IsExist=${IsExist}&QTID=${QTID}`
    );
  },
  GetQualifyingTrainingStatus() {
    return axios.get(
      `/Api/Admin/QualifyingTraining/GetQualifyingTrainingStatus`
    );
  },
  GetQualifyingTrainingRequimnt(id) {
    return axios.get(
      `/Api/Admin/QualifyingTraining/GetQualifyingTrainingRequimnt?id=${id}`
    );
  },

  GetQualifyingTrainingFoundation(pageNo, pageSize) {
    return axios.get(
      `/Api/Admin/QualifyingTraining/GetQualifyingTrainingFoundation?pageno=${pageNo}&pagesize=${pageSize}`
    );
  },
  GetQualifyingTrainingInfo(trainingFoundationId) {
    return axios.get(
      `/Api/Admin/QualifyingTraining/Get?trainingFoundationId=${trainingFoundationId}`
    );
  },
  GetQualifyingTrainingFoundateionFullInfo(id) {
    return axios.get(
      `/Api/Admin/QualifyingTraining/GetQualifyingTrainingFoundateionFullInfo?id=${id}`
    );
  },
  RegesterQualifyingTraining(bodyObject) {
    return axios.post(
      `Api/Admin/QualifyingTraining/RegesterQualifyingTraining`,
      bodyObject
    );
  },
  GetAllQualifyingTrainingRequestes() {
    return axios.get(`/Api/Admin/QualifyingTraining/Requests/Get/All`);
  },
  deleteQualifyingTrainingRequest(id) {
    return axios.post(
      `/Api/Admin/QualifyingTraining/${id}/deleteQualifyingTrainingRequest`
    );
  },

  EditRegesterQualifyingTraining(bodyObject) {
    return axios.post(
      `Api/Admin/QualifyingTraining/EditRegesterQualifyingTraining`,
      bodyObject
    );
  },
  AddNewProgram(bodyObject) {
    return axios.post(`Api/Admin/QualifyingTraining/AddNewProgram`, bodyObject);
  },
  GetConfig() {
    return axios.get(`/api/Config`);
    },

    // **********************************    Municipalities ***********************

    GetMunicipalities(pageNo, pageSize) {
        return axios.get(
            `/Api/Admin/Municipalities/Get?pageno=${pageNo}&pagesize=${pageSize}`
        );
    },
    GetAllMunicipalities() {
        return axios.get(`/Api/Admin/Municipalities/GetAllMunicipalities`);
    },
    AddMunicipality(OBJ) {
        return axios.post(`/Api/Admin/Municipalities/Add`, OBJ);
    },
    DeleteMunicipality(MunicipalitieId) {
        return axios.post(`/Api/Admin/Municipalities/${MunicipalitieId}/Delete`);
    },
    GetMunicipality(MunicipalitieId) {
        return axios.get(`/Api/Admin/Municipalities/Get/${MunicipalitieId}`);
    },
    EditMunicipality(object) {
        return axios.post(`/Api/Admin/Municipalities/Edit`, object);
    },
    GetMunicipalitieOffies(OfficeId) {
      return axios.get(`/Api/Admin/Municipalities/GetMunicipality?OfficeId=${OfficeId}`)
  },
  // *************************************News****************************************

  GetNews(pageNo, pageSize) {
    return axios.get(
      `Api/Admin/News/GetNews?pageno=${pageNo}&pagesize=${pageSize}`
    );
  },
  DelteNews(newsId) {
    return axios.post(`Api/Admin/News/DelteNews?newsId=${newsId}`);
  },
  AddNews(news) {
    return axios.post("Api/Admin/News/AddNews", news);
  },
  EditNews(news) {
    return axios.post("Api/Admin/News/EditNews", news);
  },
};
